export default __webpack_public_path__ + "static/media/ASR_UDS_DEGISIM_NEDENLERI.0c564b15.xlsx";